import React from "react";

export const Illustration6 = () => {
	return (
		<svg width={264} height={215} viewBox="0 0 264 215" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M17.5001 67.5C-7.71222 94.9483 6.29274 183.047 25.5355 214L234.722 214C264.138 177.626 266.208 141.914 262.756 123.758C258.292 100.285 234.722 -5.58715 133.551 0.230849C85.4908 2.99464 42.7124 40.0517 17.5001 67.5Z"
				fill="#F5FAFF"
			/>
			<path
				d="M196.726 149C200.262 149 203.05 151.729 203.05 155C203.05 158.271 200.262 161 196.726 161C193.19 161 190.401 158.271 190.401 155C190.401 151.729 193.19 149 196.726 149Z"
				fill="#86ACCF"
				fillOpacity={0.22}
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line x1={229.165} y1={86} x2={237.536} y2={86} stroke="#315C84" strokeWidth={2} />
			<line x1={233.304} y1={82} x2={233.304} y2={90} stroke="#315C84" strokeWidth={2} />
			<line x1={230.211} y1={144} x2={238.582} y2={144} stroke="#315C84" strokeWidth={2} />
			<line x1={234.35} y1={140} x2={234.35} y2={148} stroke="#315C84" strokeWidth={2} />
			<path
				d="M4.70898 115C6.80051 115 8.41797 116.609 8.41797 118.5C8.41797 120.391 6.80051 122 4.70898 122C2.6174 122 1 120.391 1 118.5C1 116.609 2.6174 115 4.70898 115Z"
				fill="#86ACCF"
				fillOpacity={0.22}
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M72.7253 66C75.3948 66 77.4812 68.057 77.4812 70.5C77.4812 72.943 75.3948 75 72.7253 75C70.056 74.9998 67.9705 72.9429 67.9705 70.5C67.9705 68.0571 70.056 66.0002 72.7253 66Z"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M168.24 174H218.933C221.142 174 222.933 175.791 222.933 178V213H164.24V178C164.24 175.791 166.031 174 168.24 174Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M165.333 178C165.333 176.343 166.676 175 168.333 175H218.84C220.496 175 221.84 176.343 221.84 178V185H165.333V178Z"
				fill="#C4DBF1"
				fillOpacity={0.49}
			/>
			<line x1={174.705} y1={168} x2={174.705} y2={174} stroke="#315C84" strokeWidth={2} />
			<line x1={182.03} y1={168} x2={182.03} y2={174} stroke="#315C84" strokeWidth={2} />
			<line x1={190.401} y1={168} x2={190.401} y2={174} stroke="#315C84" strokeWidth={2} />
			<line x1={197.726} y1={168} x2={197.726} y2={174} stroke="#315C84" strokeWidth={2} />
			<line x1={206.097} y1={168} x2={206.097} y2={174} stroke="#315C84" strokeWidth={2} />
			<line x1={213.422} y1={168} x2={213.422} y2={174} stroke="#315C84" strokeWidth={2} />
			<line x1={175.797} y1={192} x2={205.097} y2={192} stroke="#315C84" strokeWidth={2} />
			<line x1={175.797} y1={200} x2={194.633} y2={200} stroke="#315C84" strokeWidth={2} />
			<path
				d="M106.502 44H204.282C206.492 44 208.282 45.7909 208.282 48V137C208.282 139.209 206.492 141 204.282 141H106.502C104.293 141 102.502 139.209 102.502 137V48C102.502 45.7909 104.293 44 106.502 44Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line x1={117.198} y1={66.5} x2={192.54} y2={66.5} stroke="#C4DBF1" strokeWidth={7} />
			<line x1={149.637} y1={104.5} x2={192.54} y2={104.5} stroke="#C4DBF1" strokeWidth={7} />
			<line x1={149.637} y1={123.5} x2={192.54} y2={123.5} stroke="#C4DBF1" strokeWidth={7} />
			<line x1={117.198} y1={86.5} x2={177.89} y2={86.5} stroke="#C4DBF1" strokeWidth={7} />
			<path
				d="M37.4387 98H147.777C149.986 98.0002 151.777 99.791 151.777 102V213H33.4387V102C33.4387 99.7909 35.2296 98 37.4387 98Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line x1={63.8313} y1={140} x2={129.755} y2={140} stroke="#C4DBF1" strokeWidth={4} />
			<line x1={44.9958} y1={115.5} x2={110.92} y2={115.5} stroke="#C4DBF1" strokeWidth={7} />
			<path
				d="M51.2742 135C54.2326 135 56.5525 137.281 56.5525 140C56.5525 142.719 54.2326 145 51.2742 145C48.3158 145 45.9958 142.719 45.9958 140C45.9958 137.281 48.3158 135 51.2742 135Z"
				fill="#86ACCF"
				fillOpacity={0.22}
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line x1={64.8777} y1={167} x2={137.08} y2={167} stroke="#C4DBF1" strokeWidth={4} />
			<path
				d="M51.2742 162C54.2326 162 56.5525 164.281 56.5525 167C56.5525 169.719 54.2326 172 51.2742 172C48.3158 172 45.9958 169.719 45.9958 167C45.9958 164.281 48.3158 162 51.2742 162Z"
				fill="#86ACCF"
				fillOpacity={0.22}
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line x1={63.8313} y1={194} x2={115.106} y2={194} stroke="#C4DBF1" strokeWidth={4} />
			<path
				d="M51.2742 189C54.2326 189 56.5525 191.281 56.5525 194C56.5525 196.719 54.2326 199 51.2742 199C48.3158 199 45.9958 196.719 45.9958 194C45.9958 191.281 48.3158 189 51.2742 189Z"
				fill="#86ACCF"
				fillOpacity={0.22}
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line x1={5.23218} y1={213} x2={244.861} y2={213} stroke="#315C84" strokeWidth={2} />
			<path
				d="M177.367 20C179.459 20.0001 181.076 21.6093 181.076 23.5C181.076 25.3907 179.459 26.9999 177.367 27C175.276 27 173.658 25.3907 173.658 23.5C173.658 21.6093 175.276 20 177.367 20Z"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line x1={97.3164} y1={12} x2={105.688} y2={12} stroke="#315C84" strokeWidth={2} />
			<line x1={101.456} y1={8} x2={101.456} y2={16} stroke="#315C84" strokeWidth={2} />
			<path
				d="M166.723 140.759C172.59 148.144 171.09 158.695 163.338 164.319C155.585 169.942 144.549 168.486 138.683 161.101C132.816 153.715 134.315 143.165 142.067 137.541C149.82 131.917 160.856 133.374 166.723 140.759Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M147.914 159L142.218 151.234C141.876 150.767 141.969 150.092 142.426 149.726L144.08 148.399C144.537 148.033 145.184 148.115 145.526 148.581L149.363 153.813L160.331 145.017C160.788 144.651 161.436 144.732 161.778 145.199L163.017 146.889C163.359 147.355 163.266 148.03 162.81 148.397L149.36 159.182C148.903 159.548 148.256 159.467 147.914 159Z"
				fill="#C4DBF1"
			/>
		</svg>
	);
};
